import React from "react";

export function Logo({ size = 40, showText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <div
        style={{ width: size, height: size }}
        className="rounded-lg bg-primary text-primary-foreground font-display font-black flex items-center justify-center shadow-[0_3px_0_hsl(var(--primary)/0.5)]"
      >
        <span style={{ fontSize: size * 0.55 }}>G</span>
      </div>
      {showText && (
        <div className="leading-tight">
          <div className="font-display font-extrabold tracking-tight text-lg">Globo</div>
          <div className="font-editorial italic text-xs text-muted-foreground -mt-0.5">l'Émergence</div>
        </div>
      )}
    </div>
  );
}
